import React from 'react';
import {useTheme} from 'styled-components';
import {whereVariant} from '../../utils';
import {
  StyledSvg,
  lineIconSizeVariants,
  getIconColor,
} from '../../components/utils/Icon';

const Clear = () => (
  <path
    d="M12 0C12 0 12 0 12 0C9.62662 0 7.30654 0.703788 5.33315 2.02236C3.35976 3.34094 1.82169 5.21509 0.913443 7.4078C0.0051918 9.60051 -0.232448 12.0133 0.230574 14.3411C0.693597 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33114 23.3064 9.65891 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9908 8.82024 22.7235 5.77336 20.4751 3.52492C18.2266 1.27648 15.1798 0.00923395 12 0C12 0 12 0 12 0ZM16.243 14.829C16.6335 15.2195 16.6335 15.8525 16.243 16.243C15.8525 16.6335 15.2195 16.6335 14.829 16.243L12.7071 14.1211C12.3166 13.7306 11.6834 13.7306 11.2929 14.1211L9.171 16.243C8.78053 16.6335 8.14746 16.6335 7.757 16.243C7.36653 15.8525 7.36653 15.2195 7.757 14.829L9.87889 12.7071C10.2694 12.3166 10.2694 11.6834 9.87889 11.2929L7.757 9.171C7.36653 8.78053 7.36653 8.14746 7.757 7.757C8.14746 7.36653 8.78053 7.36653 9.171 7.757L11.2929 9.87889C11.6834 10.2694 12.3166 10.2694 12.7071 9.87889L14.829 7.757C15.2195 7.36654 15.8525 7.36653 16.243 7.757C16.6335 8.14746 16.6335 8.78053 16.243 9.171L14.1211 11.2929C13.7306 11.6834 13.7306 12.3166 14.1211 12.7071L16.243 14.829Z"
    fill="#CFD8E3"
  />
);

const CircleIcon = () => <circle cx="12" cy="12" r="12" fill="#E2E8F0" />;

const CheckRound = ({fill}) => (
  <>
    <g clipPath="url(#clip0)">
      <path
        d="M12 0a12 12 0 1012 12A12.035 12.035 0 0012 0zm-1.293 16.707a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414l2.586 2.586a1 1 0 001.414 0l6.586-6.586a1 1 0 111.414 1.414l-8 8z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0h24v24H0V0z" fill="#fff" />
      </clipPath>
    </defs>
  </>
);

const Star = ({fill}) => (
  <path
    d="M12 2.896l2.935 5.993 6.565.967-4.75 4.662 1.121 6.586L12 17.993l-5.871 3.111 1.121-6.586L2.5 9.856l6.564-.967L12 2.896z"
    fill={fill}
  />
);

const Roger = ({fill}) => (
  <path
    d="M2.192 7.287C2.566 7.642 2.597 8.238 2.24 8.61 1.883 8.982 1.285 9.013.911 8.658.537 8.303.506 7.707.863 7.335 1.22 6.963 1.814 6.948 2.192 7.287ZM12.178.297C11.822.67 11.852 1.265 12.226 1.62 12.6 1.975 13.199 1.944 13.555 1.572 13.912 1.2 13.881.604 13.508.249 13.134-.105 12.535-.075 12.178.297ZM20.44 20.542C25.306 15.74 25.148 7.901 20.185 3.296 19.043 2.244 17.759 1.444 16.379.909 15.913.735 15.394 1.002 15.283 1.481 15.19 1.88 15.401 2.282 15.791 2.422 16.97 2.878 18.093 3.573 19.08 4.489 23.361 8.466 23.496 15.24 19.305 19.39 15.448 23.196 9.22 23.38 5.146 19.821 2.59 17.586 1.409 14.372 1.664 11.235 1.689 10.838 1.439 10.46 1.037 10.368.54 10.254.071 10.601.036 11.114-.246 14.732 1.111 18.424 4.058 21.018 8.738 25.17 15.967 24.963 20.44 20.542ZM16.215 19.673C16.742 19.659 17.149 19.214 17.116 18.702 17.102 18.178 16.656 17.773 16.141 17.806 15.614 17.819 15.207 18.264 15.24 18.776 15.257 19.284 15.704 19.69 16.215 19.673ZM12.078 3.352C10.983 3.336 9.94 3.534 8.98 3.885 8.5 4.06 8.299 4.636 8.566 5.085 8.776 5.419 9.186 5.547 9.555 5.413 10.332 5.12 11.193 4.982 12.071 4.982 15.695 5.023 18.745 7.826 19.061 11.413 19.208 13.112 18.749 14.722 17.854 16.03 17.625 16.364 17.669 16.828 17.997 17.088L18.042 17.115C18.395 17.415 18.952 17.341 19.209 16.963 20.299 15.397 20.871 13.443 20.722 11.391 20.378 6.906 16.596 3.397 12.078 3.352ZM7.063 6.976C7.346 6.705 7.41 6.282 7.2 5.948 6.929 5.516 6.304 5.44 5.935 5.792 4.192 7.477 3.149 9.861 3.268 12.478 3.493 16.97 7.181 20.591 11.709 20.74 12.244 20.762 12.759 20.729 13.265 20.66 13.739 20.584 14.05 20.117 13.938 19.654 13.831 19.243 13.435 18.984 13.032 19.043 12.785 19.087 12.526 19.111 12.255 19.116 8.335 19.259 5.041 16.198 4.915 12.301 4.825 10.212 5.653 8.317 7.063 6.976ZM16.702 14.807C17.95 12.705 17.6 10.136 16.084 8.442 15.709 8.02 15.015 8.096 14.745 8.606 14.59 8.907 14.625 9.268 14.853 9.522 15.938 10.746 16.167 12.598 15.231 14.082 14.214 15.698 12.096 16.305 10.376 15.49 9.478 15.065 8.83 14.361 8.483 13.525 8.354 13.209 8.043 13.02 7.703 13.026 7.125 13.044 6.752 13.631 6.985 14.156 7.486 15.347 8.431 16.371 9.712 16.968 12.222 18.167 15.284 17.205 16.702 14.807ZM11.733 7.023C11.49 7.488 11.663 8.049 12.131 8.291 12.599 8.533 13.163 8.36 13.406 7.895 13.649 7.429 13.475 6.868 13.008 6.626 12.54 6.384 11.972 6.573 11.733 7.023ZM6.749 10.15C6.506 10.615 6.68 11.176 7.147 11.418 7.615 11.66 8.179 11.487 8.422 11.022 8.665 10.556 8.491 9.995 8.024 9.753 7.552 9.527 6.988 9.7 6.749 10.15Z"
    fill={fill}
  />
);

const FillIcon = ({
  name,
  size = 'default',
  color = 'default',
  strokeColor = 'none',
  ...props
}) => {
  const theme = useTheme();
  const sizeStyles = lineIconSizeVariants.find(whereVariant(size));
  const fillColor = getIconColor(color, theme);
  let stroke = strokeColor;
  if (stroke !== 'none') {
    stroke = getIconColor(color, theme);
  }
  return (
    <StyledSvg
      viewBox="0 0 24 24"
      fill={fillColor}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...sizeStyles}
      {...props}>
      {(() => {
        switch (name) {
          case 'clear':
            return <Clear />;
          case 'circle':
            return <CircleIcon />;
          case 'checkRound':
            return <CheckRound />;
          case 'roger':
            return <Roger />;
          case 'star':
            return <Star />;
          default:
            return null;
        }
      })()}
    </StyledSvg>
  );
};

export default FillIcon;
